export default __webpack_public_path__ + "media/other.361f6cce.svg";